import { useMemo } from "react";
import styles from "./progressIndicator.css";

/**
 * ProgressIndicator is a functional component used to render a multi-step progress indicator.
 * It visually represents the progress across a series of steps, where each step can be in one of three states:
 * "inactive," "active," or "success."
 *
 * @param {Object} props - The properties object.
 * @param {number} [props.countItems=5] - The total number of steps to display in the progress indicator.
 * @param {number} props.step - The current step indicating progress, starting from 0.
 * @param {boolean} [props.lastStepShowsActive=false] - Condition that indicates if the last step should be "active" or "success".
 */

const ProgressIndicator = ({
  countItems = 5,
  step,
  lastStepShowsActive = false,
}) => {
  const stepperItems = useMemo(() => {
    return Array.from({ length: countItems }, (_, index) => {
      let state;

      if (step === countItems) {
        state = lastStepShowsActive ? "active" : "success";
      } else if (index < step) {
        state = "active";
      } else {
        state = "inactive";
      }

      return { key: index, state };
    });
  }, [countItems, step, lastStepShowsActive]);

  return (
    <div className={styles.container}>
      {stepperItems.map(({ key, state }) => (
        <div className={styles.stepperItem({ state })} key={key} />
      ))}
    </div>
  );
};

export default ProgressIndicator;
